<div
    class="form-block-container"
    [ngClass]="{
        'form-block-container--dark': theme === 'dark'
    }"
>
    <div class="form-block-container__content">
        <div
            class="form-block-container__content__side form-block-container__content__side__left"
        >
            <ng-container
                *ngTemplateOutlet="sideTemplate; context: { content: lefthandcontent }"
            ></ng-container>
        </div>
        <div
            class="form-block-container__content__side form-block-container__content__side__right"
        >
            <ng-container
                *ngTemplateOutlet="sideTemplate; context: { content: righthandcontent }"
            ></ng-container>
        </div>
        <ng-template #sideTemplate let-content="content">
            @for (block of content; track block) {
                <div class="form-block-container__block">
                    @if (block.form) {
                        <nw-form
                            [formheading]="block.form.formheading"
                            [pageid]="block.form.pageid"
                            [showlogin]="block.form.showlogin"
                            [showtermsandprivacypolicy]="
                                block.form.showtermsandprivacypolicy
                            "
                            [privacyPolicyUrl]="block.form.privacypolicyurl"
                            [termsUrl]="block.form.termsurl"
                        ></nw-form>
                    }
                    @if (block.contentCard) {
                        <nw-content-card
                            [heading]="block.contentCard.heading"
                            [content]="block.contentCard.content"
                            [theme]="block.contentCard.theme"
                            [icon]="block.contentCard.icon"
                            [clickableurl]="block.contentCard.clickableurl"
                        ></nw-content-card>
                    }
                    @if (block.video) {
                        <nw-video
                            [videoUrl]="block.video.videourl"
                            [thumbnail]="block.video.thumbnail"
                            [duration]="block.video.duration"
                        ></nw-video>
                    }
                    @if (block.image) {
                        <img
                            class="form-block-container__block__image"
                            [ngSrc]="block.image.imageurl"
                            [alt]="block.image.alttext"
                            height="200"
                            width="200"
                        />
                    }
                </div>
            }
        </ng-template>
    </div>
</div>
